import * as React from "react";
const SvgUncheckedCheckbox = props => <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="0 0 20 20" {...props}><rect width={19} height={19} x={0.5} y={0.5} fill="#fff" stroke="#EAEAEA" rx={3.5} /></svg>;
export default SvgUncheckedCheckbox;